import React, { useState } from "react";
import moreIcon from "../icon/DotsThreeOutline.svg";
import "../style/typography.scss";
import Popover from "./Popover";
import Button from "./Button";
import PropTypes from "prop-types";

/**
 * Action button component that displays actions in popover when clicked.
 * WARNING: if actions/labels are dynamic, memoize the actions array to prevent unnecessary re-renders, and to make sure the new actions are pushed to this component.
 *
 * @param {object} props - React props object
 * @param {{ label: React.ReactNode; onClick: (event: React.MouseEventHandler<HTMLButtonElement>) => void; disabled?: boolean }[]} props.actions
 * Array of action objects. Each action object must have a label, onClick function, and optional disabled boolean.
 */
function ActionButton({ actions }) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    return (
        <Popover
            isOpen={isPopoverOpen}
            showArrow
            onClickOutside={() => setIsPopoverOpen(false)}
            contentStyle={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
            }}
            content={
                <>
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            className="lnk-color btn-sm"
                            disabled={action.disabled}
                            onClick={(e) => {
                                if (action.disabled) {
                                    return;
                                }
                                setIsPopoverOpen(false);
                                action.onClick(e);
                            }}
                        >
                            {action.label}
                        </button>
                    ))}
                </>
            }
        >
            <Button
                svg={moreIcon}
                round
                className="btn-secondary-gray btn-xs"
                onClick={(_) => {
                    setIsPopoverOpen(!isPopoverOpen);
                }}
            />
        </Popover>
    );
}

ActionButton.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            disabled: PropTypes.bool,
        }),
    ).isRequired,
};

export default ActionButton;
